/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { model_rule_category_full } from './model_rule_category_full';
import type { model_rule_change_model_rule_full } from './model_rule_change_model_rule_full';
import type { model_rule_change_profil_full } from './model_rule_change_profil_full';
import type { profil_type_lvls } from './profil_type_lvls';
export type model_rule_full = {
  id: string;
  version_id: number;
  name: string | null;
  description: string | null;
  type_lvl: profil_type_lvls;
  type_rule: model_rule_full.type_rule;
  can_be_enchanted: boolean;
  is_visible: boolean;
  hidden: boolean;
  wizard_level: model_rule_full.wizard_level;
  model_rule_categories: Array<model_rule_category_full>;
  change_profils: Array<model_rule_change_profil_full>;
  change_model_rules: Array<model_rule_change_model_rule_full>;
};
export namespace model_rule_full {
  export enum type_rule {
    EQUIPMENT = 'Equipment',
    SPECIAL_RULE = 'SpecialRule',
  }
  export enum wizard_level {
    NO_WIZARD = 'NoWizard',
    WIZARD = 'Wizard',
    WIZARD_APPRENTICE = 'WizardApprentice',
    WIZARD_ADEPT = 'WizardAdept',
    WIZARD_MASTER = 'WizardMaster',
  }
}
